<template>
  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width" v-show="!cadastro"> 
          <div slot="header">
            <h4 class="card-title">Lista de produtos</h4>
            <button class="btn btn-info" @click="exibirCadastro" v-if="cadastroWeb">Novo Produto</button>
            <button class="btn btn-success" @click="exibirHistoricoEstoque">Histórico de Estoque</button>
            <input class="pull-right form-control" placeholder="Pesquisar..." v-debounce:250ms="search" v-model="query" style="max-width: 250px">
          </div>
          <div class="col-md-12">
              <download-excel
                    :fetch="fetchData"
                    :title="'Relatório de Produtos'"
                    name="Produtos.xls"
                    class="d-inline-block pull-right"
              > 
                <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Exportar Excel</n-button>
              </download-excel>
            </div>
          <div class="px-3">
            <div class="mb-3">
              <div v-for="produto of produtos" class="row py-2 px-2 bordered-block-table only-mobile">
                <div class="col-6">
                  <strong>{{ produto.descricao}}</strong>
                  <br>
                  Cód: {{ produto.referencia }}
                </div>
                <div class="col-4">
                  Val. {{ produto.valor_venda | currencyBrl(false)}}
                  <br>
                  Est.: {{ produto.estoque_atual}}
                </div>
                <div class="col-2">
                  <button class="btn btn-sm btn-edit px-2 py-1" @click="editarProduto(produto)" style="font-size: 10px"><i class="fa fa-pencil"></i></button>
                </div>
              </div>
            </div>

            <table class="table table-striped hidden-mobile">
              <thead>
                <tr>
                  <th v-if="config_modulo_busca_id" style="width: 10px">Cód Interno</th>
                  <th style="width: 10px">Cód.</th>
                  <th style="width: 300px" class="text-right">Nome Produto</th>
                  <th class="text-right">Valor da venda</th>
                  <th class="text-right">Valor de custo</th>
                  <th class="text-center pr-4">Estoque</th>
                  <th class="text-center" v-if="cadastroWeb"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="produto of produtos">
                  <td v-if="config_modulo_busca_id">{{ produto.codigo }}</td>
                  <td>{{ produto.referencia }}</td>
                  <td class="text-right">{{ produto.descricao }}</td>
                  <td class="text-right">{{ produto.valor_venda | currencyBrl(true) }}</td>
                  <td class="text-right">{{ produto.valor_custo | currencyBrl(true) }}</td>
                  <td class="text-center pr-3" style="min-width:200px;">
                    <div>
                      <div class="d-inline-block">
                       <button class="btn btn-success btn-sm px-2 py-1" @click="handleAumentar(produto)" style="font-size: 10px" v-if="cadastroWeb"><i class="fa fa-plus"></i></button>
                      </div>
                      <div class="d-inline-block text-center" style="min-width:80px;">
                       {{ produto.estoque_atual }}
                      </div>
                      <div class="d-inline-block">
                      <button class="btn btn-danger btn-sm px-2 py-1" @click="handleDiminuir(produto)" style="font-size: 10px" v-if="cadastroWeb"><i class="fa fa-minus"></i></button>
                      </div>
                    </div>
                  </td>
                  <td class="text-right">
                    <template v-if="!cadastroWeb">
                      <button class="btn btn-sm btn-info px-2 py-1" @click="openImpostos(produto)" style="font-size: 10px"><i class="fa fa-info"></i></button>
                    </template>
                    <template v-if="cadastroWeb">
                      <button class="btn btn-sm btn-edit mr-1 px-2 py-1" @click="editarProduto(produto)" style="font-size: 10px"><i class="fa fa-pencil"></i></button>
                      <button class="btn btn-sm btn-danger px-2 py-1" @click="excluirProduto(produto)" style="font-size: 10px" ><i class="fa fa-close"></i></button>
                    </template>
                  </td>
                </tr>
                <tr v-if="!produtos || !produtos.length">
                  <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
                </tr>
              </tbody>
            </table>

            <div class="row">
              <div class="col-12 col-md-6 text-center-mobile">
                Mostrando de {{ from }} até {{ to }} de {{ total}} registros
              </div>
              <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
                  <paginate
                  :pageCount="pageCount"
                  :clickHandler="changePage"
                  :prevText="'Ante.'"
                  :nextText="'Próx.'"
                  :containerClass="'pagination'">
                </paginate>
              </div>
            </div>
          </div>
        </card>

        <card card-body-classes="table-full-width" v-show="cadastro"> 
          <div class="card-body" >
            <h4 class="card-title">Cadastro de Produtos</h4>
            <button class="btn btn-info" @click="exibirLista">Exibir Produtos</button>
            <form class="m-t-40" @keydown.enter.prevent v-on:submit.prevent="update(Produtos)">
              <div class="row col-md-8 col-12 pt-10">
                <div class="form-group col-md-6">
                  <label>Nome do Produto</label>
                  <input type="text" class="form-control" placeholder="Obrigatório" required v-model="Produtos.descricao">
                </div>
                <div v-if="config_modulo_busca_id" class="form-group col-md-3">
                  <label>Código Interno</label>
                  <input type="text" class="form-control" v-model="Produtos.codigo" readonly>
                </div>
                <div class="form-group col-md-3">
                  <label>Código</label>
                  <input type="text" class="form-control" @keydown.enter.prevent="" placeholder="Opcional" v-model="Produtos.referencia">
                </div>

                <div class="form-group col-md-6">
                  <label>Valor Venda (R$)</label>
                  <money type="text" class="form-control" required placeholder="Obrigatório" v-model="Produtos.valor_venda"></money>
                </div>
                <div class="form-group col-md-6" v-show="config_modulo_atacado">
                  <label>Valor Venda Atacado (R$)</label>
                  <money type="text" class="form-control" placeholder="" v-model="Produtos.valor_atacado"></money>
                </div>
                <div class="form-group col-md-6">
                  <label>Valor Custo (R$)</label>
                  <money type="text" class="form-control" placeholder="" v-model="Produtos.valor_custo"></money>
                </div>
                <div class="form-group col-md-6">
                  <label>Unidade Comercial</label>
                    <select class="form-control" v-model="Produtos.unidade">
                      <option value="1">Unidade</option>
                      <option value="2">Caixa</option>
                      <option value="3">Quilo</option>
                      <option value="4">Peca</option>
                      <option value="5">Metro</option>
                      <option value="6">Fardo</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>NCM </label> 
                    <a @click="findNCM" style="cursor: pointer;"><i title="Nomenclatura Comum do Mercosul - 8 dígitos numéricos" class="fa fa-question-circle" style="color: #19a1e6;"></i></a>
                    <input type="text" maxlength="8" class="form-control" required placeholder="Obrigatório" v-model="Produtos.ncm_sh">
                  </div>
                </div>
                <hr/>
                <h6><label>Informações tributárias</label></h6><a style="color:white; font-size:8px" :class="{ 'btn btn-sm btn-light fa fa-plus': !detalhamento, 'btn btn-sm btn-light fa fa-minus': detalhamento,  }" @click="detalhamento = !detalhamento"></a>

              <div class="row col-md-8 col-12 pt-10 container-fluid well" v-show="detalhamento">
                <div class="form-group col-md-6">
                  <label>CEST</label>
                  <input type="number" class="form-control" placeholder="" v-model="Produtos.cest">
                </div>
                <div class="form-group col-md-6">
                  <label>CST</label>
                  <input type="number" class="form-control" size="3" placeholder="" v-model="Produtos.cst">
                </div>
                <div class="form-group col-md-6">
                  <label>CFOP</label>
                  <input type="number" class="form-control" size="4" placeholder="" v-model="Produtos.cfop">
                </div>
              </div>
                <hr/>

              <div class="row col-md-8 col-12 pt-10">
                <div class="form-group col-md-6">
                  <label>Estoque Atual</label>
                  <input type="number" step="0.01" class="form-control" placeholder="" v-model="Produtos.estoque_atual">
                </div>
                <div class="form-group col-md-6" v-show="config_modulo_estoque">
                  <label>Estoque Minimo</label>
                  <input type="number" class="form-control" placeholder="" v-model="Produtos.estoque_minimo">
                </div>
                <div class="form-group col-md-6" v-if="config_modulo_categoria">
                  <label>Categoria</label>
                  <select class="form-control" v-model="Produtos.categoria">
                    <option v-for="(categoria, index) in categorias" :key="index" :value="categoria.codigo">{{categoria.descricao}}</option>
                  </select>
                </div>
                <div class="form-group col-md-3" style="padding:15px">
                  <input type="checkbox" id="atalho" class="filled-in" v-model="Produtos.atalho">
                  <label>Favorito</label>
                </div>
                <div class="form-group col-md-3" style="padding:15px">
                  <input type="checkbox" id="atalho" class="filled-in" v-model="Produtos.tipo_produto">
                  <label>Pesável</label>
                </div>
                <!-- <div class="form col-md-6">
                  <label>Estoque</label>
                  <input type="number" step="0.01" class="form-control" placeholder="" v-model="Produtos.estoque_atual">
                </div> -->
                
                  <div class="form-group col-md-12">
                  <div class="row">
                    <div class="form-group col-md-3">
                      <label>Código de Barras (EAN)</label>
                      <input type="text" class="form-control" placeholder="" v-model="ean">
                    </div>
                    <div class="form-group col-md-1">
                      <button @click="adicionarEan(Produtos)" style="margin-top: 35px" type="button" class="btn btn-sm btn-success"><i class="fa fa-plus"></i></button>
                    </div>
                    <div class="form-group col-md-8">
                      <label for="eans"></label>
                      <ul id="eans">
                        <li v-for="(item, index) in Produtos.ean" :key="index"> {{ item.ean }} <i @click="removerEan(index)" class="fa fa-trash" style="color: red"></i></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mt-2">
                  <div style="position: relative; width: 200px; height: 200px; margin-bottom: 20px">
                    <img v-if="prevImgUrl" :src="prevImgUrl" class="img-preview" :class="{ 'loading-upload': percentCompleted != 0 && percentCompleted != 100 }">
                    <p style="position: absolute; top: 50%; font-weight: bold; font-size: 24px; left: 43%;" v-if="percentCompleted != 0 && percentCompleted != 100">{{ percentCompleted }}%</p>
                  </div>
                  <image-uploader
                    :id="'fileInput'"
                    :debug="0"
                    :maxWidth="384"
                    :quality="1.0"
                    :autoRotate=true
                    outputFormat="verbose"
                    :preview=false
                    :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
                    :capture="false"
                    accept="image/*"
                    doNotResize="['gif', 'svg']"
                    @input="setImage"
                  >
                  </image-uploader> 
                  <label for="fileInput" slot="upload-label" style="background-color: #eee; border: 1px solid #ccc; width: 200px; text-align: center; color: #000; padding: 10px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                      <span class="upload-caption">{{ hasImage ? 'Alterar foto do produto' : 'Enviar foto do produto' }}</span>
                    </label>
                </div>        
              
                <div class="col-md-12">
                  <button class="btn btn-info mr-10" :class="{ disabled: percentCompleted != 0 && percentCompleted != 100 }">{{ Produtos.codigo ? 'Salvar': 'Cadastrar'}}</button>
                  <!-- <button class="btn btn-secondary ml-3 mr-10">Limpar</button> -->
                </div>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
  import moment from 'moment'
  import ProdutoService from '@/services/ProdutoService.js'
  import { http } from '@/services/HttpService.js'
  import ErrorService from '@/services/ErrorService.js'


  export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        produtos: [],
        ean:"",
        current_page: 1,
        pageCount: 0,
        categorias:[],
        cadastro: false,
        Produtos: ({}),
        from: 0,
        to: 0,
        total: 0,
        hasImage: false,
        prevImgUrl: "https://cdn-adonis.s3.sa-east-1.amazonaws.com/999920190828163217n5E4UhqyH.jpg",
        image: null,
        loadingUpload: false,
        percentCompleted: 0,
        query: "",
        cadastroWeb: localStorage.getItem('config_modulo_cadastro_web') == "true" && !window.accessLevel ? true : false,
        config_modulo_categoria: localStorage.getItem('config_modulo_categoria') == "true" && !window.accessLevel ? true : false,
        config_modulo_atacado: localStorage.getItem('config_modulo_atacado') == "true" && !window.accessLevel ? true : false,
        config_modulo_estoque: localStorage.getItem('config_modulo_estoque') == "true" && !window.accessLevel ? true : false,
        config_modulo_busca_id: localStorage.getItem('config_modulo_busca_id') == "true" && !window.accessLevel ? true : false,
        detalhamento: false,

      }
    },
    methods:{
      loadProdutos() {
        ProdutoService.load(`?page=${this.current_page}`+ "&query=" + this.query).then(res => {
          this.pageCount = res.data.produtos.last_page
          this.produtos = res.data.produtos.data
          this.categorias = res.data.categorias
          this.from = res.data.produtos.from
          this.to = res.data.produtos.to
          this.total = res.data.produtos.total
        })
      },
      search() {
        this.current_page = 1
        this.loadProdutos()
      },
      exibirHistoricoEstoque() {
        this.$router.push('/historico-estoque')
      },
      debounce(callback, time) {
        var timeout;
        return function() {
          var context = this;
          var args = arguments;
          if (timeout) {
            clearTimeout(timeout);
          }
          timeout = setTimeout(function() {
            timeout = null;
            callback.apply(context, args);
          }, time);
        }
      },
      adicionarEan(produto) {
        let existe = false;

        if(produto.ean != null && this.ean) {
          produto.ean.forEach(ean => {
            if(ean == this.ean) {
              existe = true;
            }
          });
        } else {
          produto.ean = [];
        }
        if(!existe && this.ean) {
          produto.ean.push({ean:this.ean});
        }
      },
      removerEan(index) {
        this.Produtos.ean.splice(index, 1);
      },
      handleAumentar(obj){
        this.$swal({
          text: 'Digite a quantidade que deseja adicionar',
          input: "text"
        }).then(val => {
          let value = parseFloat(val.value.toString().replace(',', '.'));
          
          if(value > 0) {
            obj.estoque_atual += value;
            obj.estoque_real = value;
            ProdutoService.alteraEstoque(obj).then(ret => {
              this.$swal('Produto atualizado com sucesso!','', 'success');
              
              if(!obj.estoque_atual) {
                obj.estoque_atual = 0;
              }

              // obj.estoque_atual += parseFloat(value);
            });
          }
        });
      },
      handleDiminuir(obj){
        
        this.$swal({
          text: 'Digite a quantidade que deseja retirar',
          input: "text"
        }).then(val => {
          let value = parseFloat(val.value.toString().replace(',', '.'));

          if(value) {
            obj.estoque_atual -= value;
            obj.estoque_real = -value;
            ProdutoService.alteraEstoque(obj).then(ret => {
              this.$swal('Produto atualizado com sucesso!','', 'success');
              
              if(!obj.estoque_atual) {
                obj.estoque_atual = 0;
              }
              
              // obj.estoque_atual -= parseFloat(value);
            });
          }
        });
      },
      editarProduto(produto){
        this.Produtos = produto

        this.resetImg(produto)

        this.cadastro = true;
      },
      async fetchData() {

        let response = await ProdutoService.load(`?query=` + this.query+"&no_paginate=true")
        let dados = []

        for(let item of response.data.produtos) {
          let tmp = {
            "Código": item.referencia,
            "Nome": item.descricao,
            "Valor de Custo": this.$options.filters.currencyBrl(item.valor_custo),
            "Valor de Venda": this.$options.filters.currencyBrl(item.valor_venda),
            "Estoque": item.estoque_atual,
            "Pesável": item.tipo_produto ? "Sim" : "Não",
            "NCM":  item.ncm_sh,
            "CFOP": item.cfop,
            "CST": item.cst,
            "CEST": item.cest
          };
          
          if(this.config_modulo_busca_id){
            tmp.codigo_interno = item.codigo;
          }
          dados.push(tmp)
        }

        return dados;
      },
      update(Produto){
        if(Produto.codigo){
          ProdutoService.update(Produto).then(res => {
            this.loadProdutos()
            this.cadastro = false;
            this.$swal('Produto atualizado com sucesso!','', 'success')
          }).catch(error =>{
            ErrorService.getMessage(error.response)
            // this.$swal({
            //     text: error.response,
            //     type: "error",
            // });
          });
        }else{
          ProdutoService.create(Produto).then(res => {
            this.loadProdutos();
            this.cadastro = false;
            this.$swal('Produto cadastrado com sucesso!','', 'success')
          }).catch(error =>{
            console.log(error);
              ErrorService.getMessage(error.response)
              //   this.$swal({
              //       text: error.resonse,
              //       type: "warning",
              //   });
              });
        }
      },
      exibirLista(){
        this.loadProdutos()
        this.cadastro = false;
      },
      exibirCadastro(){
        this.Produtos = ({categoria:0,unidade:1});

        this.resetImg()

        this.cadastro = true;
      },
      resetImg(produto = null) {

        if(produto && produto.url_imagem) {
          this.prevImgUrl = produto.url_imagem
          if(produto.url_imagem.indexOf('/imagem?metodo=read&arquivo=') >= 0){
            this.prevImgUrl = 'https://tomcat.yooga.com.br/YoogaServlet'+produto.url_imagem+"&idi="+localStorage.getItem('current_idi');
          }
        } else {
          this.prevImgUrl = null;
        }
        
        document.getElementById("fileInput").value = ""
        this.image = null;
        this.$forceUpdate();
      },
      excluirProduto(Produto){
        this.$swal({
          title: "Desativar esse produto ?",
          text: "Atenção essa operacao não pode ser revertida !",
          type: "warning",
          showCancelButton: true,
          cancelButtonAriaLabel: 'Cancelar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#ef5350',
          confirmButtonText:'Desativar',
        }).then(result => {
          if(result.value){
            ProdutoService.destroy(Produto.codigo).then(res => {
              this.loadProdutos()
              this.cadastro = false;
              this.$swal('Produto desativado com sucesso!','', 'success')
            }).catch(e => {
              ErrorService.getMessage(e.response)
              // this.$swal('Erro ao cadastrar', e,'error')
            })
          }
        });
      },
      changePage(page) {
        this.current_page = page
        this.loadProdutos()
      },
      openImpostos(produto) {
        let html = '';

        html += "<h4 class='mb-1' style='font-size: 16px;'><strong>" + produto.descricao + "</strong></h4>"
        html += "<h4 class='mb-4 mt-0' style='font-size: 16px;'>Detalhamento de impostos</h4>"
        html += "<div class='text-left ml-4 mt-4'><p style='font-weight: normal'><strong>NCM</strong>: " + produto.ncm_sh + "</p>"
        html += "<p style='font-weight: normal'><strong>CFOP</strong>: " + produto.cfop + "</p>"
        html += "<p style='font-weight: normal'><strong>CST</strong>: " + produto.cst + "</p>"
        html += "<p style='font-weight: normal'><strong>CEST</strong>: " + produto.cest + "</p>"
        html += "<p style='font-weight: normal'><strong>% Base de Cálculo ICMS</strong>: " + produto.p_bc_icms + "</p>"
        html += "<p class='mb-1' style='font-weight: normal'><strong>% ICMS</strong>: " + produto.p_icms + "</p>"
        html += "</div>"

        this.$swal({
          html: html
        })
      },

      upload(file) {
        var data = new FormData();
        data.append('file', file);
        
        var config = {
          onUploadProgress: (progressEvent) => {
            this.percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          }
        };

        http.post('upload', data, config)
          .then(res => {
            this.Produtos.url_imagem = res.data.url
          })
          .catch(err => {
            console.error(err)
          });
      },
      setImage: function (file) {
        console.log('setImage')
        this.hasImage = true
        this.prevImgUrl = file.dataUrl;
        this.image = file
        this.upload(this.dataURLtoFile(file.dataUrl, "file"))
      },
      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
      },
      findNCM() {
         let html = '';

        html += "<h4 class='mb-4 mt-0' style='font-size: 20px;'><strong>Encontre seu NCM</strong></h4>"
        html += "<div class='text-left ml-4 mt-4'><p style='font-weight: normal'><strong>Produto</strong>:</p>"
        html += "<input type='text' class='form-control' placeholder='Produto'>"
        html += "</div>"

        this.$swal({
          html: html
        })
      }
    },
    mounted() {
      this.loadProdutos()
    }
  }
</script>


<style>
  .img-preview {
    max-width: 200px;
    max-height: 200px;
    display: block;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .loading-upload {
    opacity: 0.3
  }
</style>
